import React, { useState } from 'react';
import { Button, Col, Row } from 'reactstrap';
import moment from 'moment';
import { actionsTable } from '../../../constants/MaterialTable';
import TextField from '../../../components/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import { useAuth } from '../../../context/auth';
import exportacaoDiarioOficial_api from '../../../api/exportacaoDiarioOficial_api';
import { showMessage } from '../../../helpers/message';

function initialStateConsultaDiarioOficial() {
    const dataInicial = new Date();
    dataInicial.setMonth(dataInicial.getMonth() - 1);
    return {
        dataInicial: moment(dataInicial).format('YYYY-MM-DD'),
        dataFinal: moment(new Date()).format("YYYY-MM-DD"),
    }
}

function ExportacaoDiarioOficial() {
    //State para consultar fiscalizacoes
    const [consultaDiarioOficial, setConsultaDiarioOficial] = useState(initialStateConsultaDiarioOficial());

    //State para pegar lista exportação
    const [listaExportacaoOficial, setListaExportacaoOficial] = useState([]);

    const { setLoading } = useAuth();

    //Cabeçalhos da lista de consulta fiscalização
    const headers = [
        { value: "Data", objectValue: "data", align: "left" },
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Total de Registros", objectValue: "totalRegistro", align: "left" }
    ];

    const handleDownload = (conteudo) => {
        const filename = 'diarioOficial.txt';
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(conteudo));
        element.setAttribute('download', filename);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    };

    const loadConteudoDiarioOficial = (rowDate) => {
        const [day, month, year] = rowDate.data.split('/');
        const formattedDate = new Date(year, month - 1, day);

        setLoading(true);
        exportacaoDiarioOficial_api.ExportacaoDiarioOficial({ identificacao: rowDate.identificacao, data: formattedDate })
            .then(response => {
                handleDownload(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.imprimirTxt(loadConteudoDiarioOficial)];

    const onChange = (e) => {
        const { value, name } = e.target;
        setConsultaDiarioOficial({
            ...consultaDiarioOficial,
            [name]: value
        });
    }

    const handleConsultaDiarioOficial = () => {
        const _consultaDiarioOficial = { ...consultaDiarioOficial };

        setLoading(true);
        exportacaoDiarioOficial_api.getExportacaoDiarioOficial(_consultaDiarioOficial)
            .then(response => {
                response?.data?.map(value => {
                    value.data = moment(value.data).format("DD/MM/YYYY");
                    return value;
                })
                setListaExportacaoOficial(response.data);
            })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    return <>
        <h4 className='text-secondary m-0'>Exportação diário oficial</h4>
        <Row className='mt-3 p=0'>
            <Col md={12} lg={3}>
                <TextField
                    type={"date"}
                    name={"dataInicial"}
                    label={"* Data Inicial"}
                    onChange={onChange}
                    value={consultaDiarioOficial.dataInicial}
                />
            </Col>
            <Col md={12} lg={3}>
                <TextField
                    type={"date"}
                    name={"dataFinal"}
                    label={"* Data Final"}
                    onChange={onChange}
                    value={consultaDiarioOficial.dataFinal}
                />
            </Col>
            <Col md={12} lg={3} className='mt-2'>
                <Button
                    color='primary'
                    onClick={handleConsultaDiarioOficial}
                >
                    <FontAwesomeIcon icon={faSearch} /> Pesquisar
                </Button>
            </Col>
        </Row>
        <Row>
            <TabelaListagem
                actions={actions}
                title={"Lista diário oficial"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={listaExportacaoOficial}
            />
        </Row>
    </>;
}

export default ExportacaoDiarioOficial;